export default __webpack_public_path__ + "static/media/Image 3.b27047bc.png";